import { render, staticRenderFns } from "./MainSiteOrganizer.vue?vue&type=template&id=5accac25&scoped=true&"
import script from "./MainSiteOrganizer.vue?vue&type=script&lang=js&"
export * from "./MainSiteOrganizer.vue?vue&type=script&lang=js&"
import style0 from "./MainSiteOrganizer.vue?vue&type=style&index=0&id=5accac25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5accac25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5accac25')) {
      api.createRecord('5accac25', component.options)
    } else {
      api.reload('5accac25', component.options)
    }
    module.hot.accept("./MainSiteOrganizer.vue?vue&type=template&id=5accac25&scoped=true&", function () {
      api.rerender('5accac25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MainSiteOrganizer.vue"
export default component.exports